import { QStack, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { UniversalUserSelectionType } from '../../../../../../types';

type ChangedApprovalUsersProps = {
  users: UniversalUserSelectionType[];
  label: string;
};

export const ChangedApprovalUsers = ({ users, label }: ChangedApprovalUsersProps) => {
  const { t } = useTranslation();
  return (
    <QStack spacing="1">
      <QText fontWeight="semibold">{label}</QText>
      {users.length > 0 ? (
        users.map((user) => <QText key={user.id}>{user.label}</QText>)
      ) : (
        <QText>{t('common.labels.none')}</QText>
      )}
    </QStack>
  );
};
